import { ref, reactive } from "vue";


// 拖拽事件结束鼠标位置的数据
export const dragTarget = ref(null);

/**
 * 获取物料在数据中的哪一层
 * @params tableData { Array } 表格数据
 * @params id { number } 数据id
*/
const getTargetListById = (tableData, id) => {
    const list = [];
    // 递归数据
    function ite(iteList) {
        iteList.forEach((item) => {
            if (item.id == id) {
                list.push(...iteList);
            }

            if (item.children && item.children.length > 0) {
                ite(item.children);
            }
        });
    }
    ite(tableData);
    return list;
};

/**
 * 判断移动的物料和鼠标最后的物料是否在同一层
 * @params tableData { Array } 表格数据
 * @params moveRecord { Object } 拖拽事件开始鼠标位置的数据
*/
export const checkLevel = (tableData, moveRecord) => {
    const levelList = getTargetListById(tableData, dragTarget.value.id);
    // 没有找到数据返回错误
    if (levelList.length === 0) throw new Error('请拖拽同层的数据');
    const moveRecordIndex = levelList.findIndex((f) => f.id === moveRecord.id);
    // 没有找到数据返回错误
    if (moveRecordIndex === -1) throw new Error('请拖拽同层的数据');
    const targetIndex = levelList.findIndex((f) => f.id === dragTarget.value.id);
    return {
        list: levelList,
        startIndex: moveRecordIndex,
        endIndex: targetIndex,
    }
};


const findMaterialById = (table, id) => {
    let fitem = null;
    // 递归数据
    function ite(iteList) {
        iteList.forEach((item) => {
            if (item.id == id && item.isFrame) {
                fitem = item;
            }

            if (item.children && item.children.length > 0) {
                ite(item.children);
            }
        });
    }
    ite(table);
    return fitem;
};

/**
 * 拖拽进入的节点
*/
export const handleUpdateDragTarget = (table, event) => {
    const id = event.toElement.parentNode.dataset.rowKey;
    const frame = findMaterialById(table, id);
    if (frame) {
        dragTarget.value = frame;
    }
};


/**
 * 拖拽数据的范围
*/
const getRangeList = (list, startIndex, endIndex) => {
    // 拖拽的方向
    const direction = startIndex < endIndex ? 'bottom' : 'top';
    // 上下都是从小的开始截取数组
    const start = direction === 'bottom' ? startIndex : endIndex;
    const end = direction === 'bottom' ? endIndex : startIndex;
    let rangeList = list.slice(start, end + 1).filter((f) => f.isFrame);

    // 从下往上拖拽数组反转
    if (direction === 'bottom') {
        rangeList = rangeList.reverse().filter((f) => f.isFrame);
    }
    return rangeList;
};

/**
 * 交换排序
*/
const compareSort = (list) => {
    list.forEach((item, index) => {
        const current = item;
        const next = list[index + 1];
        if (current && next) {
            current.sequencing = current.sequencing + next.sequencing;

            next.sequencing = current.sequencing - next.sequencing;

            current.sequencing = current.sequencing - next.sequencing;
        }
    });
    return list;
};

/**
 * 处理排序
*/
export const getUpdateSortList = (list, startIndex, endIndex) => {
    // 请求数据
    const updateList = [];
    // 拖拽数据的范围
    const rangeList = getRangeList(list, startIndex, endIndex);
    // 交换排序
    const sortList = compareSort(rangeList);
    // 循环获取需要修改的数据
    sortList.forEach((item) => {
        updateList.push({
            id: item.id,
            sequencing: item.sequencing,
            name: item.materialName
        })
    });
    return updateList;
};

/**
 * 拖拽事件和业务分离
*/
const useDarg = () => {
    const dragSetting = reactive({
        mouseEnterCb: null,
        mouseLeaveCb: null,
        dragStartCb: null,
        dragEndCb: null,
        dragEnterCb: null,

        useMouseEnter: true,
        useMouseLeave: true,
        useDragStart: true,
        useDragEnd: true,
        useDragEnter: true,
    });
    /**
     * 鼠标移入
    */
    const mouseEnter = (event) => {
        if (!dragSetting.useDragEnter) return;
        event.target.draggable = true;
        if (dragSetting.mouseEnterCb) {
            dragSetting.mouseEnterCb(event);
        }
    };
    /**
     * 鼠标离开
    */
    const mouseLeave = (event) => {
        if (!dragSetting.useMouseLeave) return;
        event.target.draggable = false;
        if (dragSetting.mouseLeaveCb) {
            dragSetting.mouseLeaveCb(event);
        }
    };
    /**
     * 拖拽开始
    */
    const dragStart = (event) => {
        if (!dragSetting.useDragStart) return;
        if (dragSetting.dragStartCb) {
            dragSetting.dragStartCb(event);
        }
    };
    /**
     * 拖拽结束
    */
    const dragEnd = (event) => {
        if (!dragSetting.useDragEnd) return;
        if (dragSetting.dragEndCb) {
            dragSetting.dragEndCb(event);
        }
    };
    /**
     * 拖拽进入节点
    */
    const dragEnter = (event) => {
        if (!dragSetting.useDragEnter) return;
        if (dragSetting.dragEnterCb) {
            dragSetting.dragEnterCb(event);
        }

    };

    return {
        dragSetting,
        mouseEnter,
        mouseLeave
    }
};

/**
 * 获取customRow
*/
const getCustomRow = () => {
    const eventList = [];



    return {

    }
};

